import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SynchronizationService } from '@core/services/synchronization.service';
import { UsersService } from '@core/services/users.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReportGuard implements CanActivate {
  constructor(private users: UsersService, private sync: SynchronizationService, private router: Router) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    return new Observable<boolean>(subscriber => {
      this.sync.when(UsersService).commit(() => {
        if (!this.sync.ready(UsersService) || !this.users.current || !this.users.current.Roles.containsAny("Owner", "Accountant", "Monitor")) {
          this.router.navigateByUrl('/home');
          subscriber.next(false);
        }
        else {
          subscriber.next(true);
        }
      });
    });
  }

}
